import React, { useMemo, useRef } from 'react';
import { LinkWithGAPromoClick, SectionTitle, Swiper, SwiperSlide, Typography } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey, enhanceImageUrl, removeSpecialCharacters, replaceSpecialChars } from 'utils';
import { Banner, useModelJsonSelector } from 'modules/model-json';
import {
  adviceImage,
  adviceSectionStyle,
  adviceSlide,
  adviceSwiper,
  adviceWrapper,
} from './advice-section-styles';

/**
 * Вью секции с советами
 */
export const AdviceSection = () => {
  const { adviceSection } = useModelJsonSelector();

  const bannerRefs = useRef<HTMLImageElement[]>([]);

  const promotions = useMemo(
    () =>
      adviceSection
        ? adviceSection.banner.map((banner: Banner, index: number) => ({
            name: 'sad_middle_small_советы',
            creative: `sad_${removeSpecialCharacters(banner.title)}`,
            position: (index + 1).toString(),
          }))
        : [],
    [adviceSection]
  );

  usePromoViewEvent(bannerRefs, 'landingSad / articles', promotions);

  if (!adviceSection || adviceSection.banner.length === 0) {
    return null;
  }

  return (
    <section className={adviceSectionStyle}>
      <SectionTitle as="h2">{adviceSection.title}</SectionTitle>
      <Swiper className={adviceSwiper} slidesPerView="auto">
        {adviceSection.banner.map(({ title, image, creative, url, button }: Banner, index: number) => (
          <SwiperSlide className={adviceSlide} key={createElementKey('garden-advice', index)}>
            <LinkWithGAPromoClick
              className={adviceWrapper}
              elementBlock="landingSad / promo"
              position={index}
              promotion={promotions[index]}
              href={url}
              title={button}>
              <img
                alt={creative}
                className={adviceImage}
                data-position={index}
                height={220}
                ref={(el: HTMLImageElement | null) => {
                  if (el && bannerRefs) bannerRefs.current[index] = el;
                }}
                src={enhanceImageUrl(image)}
                title={creative}
                width={280}
              />
              <Typography variant="l" size="body_short">
                {replaceSpecialChars(title)}
              </Typography>
            </LinkWithGAPromoClick>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
